import { Component, OnDestroy, OnInit } from '@angular/core';
import { PortalProfileService } from './portal-profile.service';
import { PortalProfileModel } from './portal-profile.models';
import { AppConfigService } from 'src/app/shared/services/app-config.service';
import { Router } from '@angular/router';
import {
  AdminPortalProfileFieldModel,
  AdminPortalProfilePanelModel,
  ProfileFieldType
} from 'src/app/admin/admin-home/admin-portal/admin-portal-model';
import { PortalAttributeService } from 'src/portal/shared-services/portal-attribute.service';
import { AttributeDefinition } from 'src/app/shared/models/attributes/attributeDefinition';
import { Attribute } from 'src/app/shared/models/attributes/attribute';
import { Subscription } from 'rxjs';
import { PortalGenericAttributeFactoryService } from 'src/portal/shared-services/portal-generic-attribute-factory.service';
import { IGenericAttributeService } from 'src/shared-app-portal/interfaces/i-generic-attribute-service';
import { MatDialog } from '@angular/material/dialog';
import {
  VerifyEmailDialogComponent,
  VerifyEmailDialogData
} from 'src/portal/dialogs/verify-email.dialog/verify-email.dialog.component';
import { PersonEmailModel } from 'src/shared-app-portal/components/email-editor/person-email.model';

@Component({
  selector: 'app-portal-profile',
  templateUrl: './portal-profile.component.html',
  styleUrls: ['./portal-profile.component.scss'],
  standalone: false
})
export class PortalProfileComponent implements OnInit, OnDestroy {
  profile: PortalProfileModel;
  leftPanels: Array<AdminPortalProfilePanelModel>;
  rightPanels: Array<AdminPortalProfilePanelModel>;
  loading = true;
  private _customFields: Array<AttributeDefinition>;
  sub: Subscription;

  constructor(
    private portalProfileService: PortalProfileService,
    private appConfigService: AppConfigService,
    private portalAttributeService: PortalAttributeService,
    private portalGenericAttributeFactoryService: PortalGenericAttributeFactoryService,
    private router: Router,
    private dialog: MatDialog
  ) {}
  async ngOnInit(): Promise<void> {
    if (
      this.appConfigService.tenant.portalConfiguration &&
      this.appConfigService.tenant.portalConfiguration.showProfileTab !== true
    ) {
      this.router.navigate(['portal/not-found'], {
        skipLocationChange: true
      });
    }
    const panels = await this.portalProfileService.getProfilePanels();
    this.leftPanels = panels.filter((panel) => panel.panelLocation === 'Left');
    this.rightPanels = panels.filter((panel) => panel.panelLocation === 'Right');
    this._customFields = await this.portalAttributeService.getAttributeDefinitions();

    await this.portalProfileService.getProfile();
    this.sub = this.portalProfileService.profile.subscribe((profile) => {
      this.loading = false;

      if (profile) {
        this.profile = profile;
      }
    });
  }

  public getCustomField(customFieldId: string): AttributeDefinition | undefined {
    return this._customFields.find((field) => field.id === customFieldId);
  }
  public getCustomFieldValueByTypeId(attributeDefinitionId: string): Array<Attribute> {
    return this.profile.customFields?.filter(
      (a) => a.attributeDefinitionId == attributeDefinitionId
    );
  }
  public isEmpty = (attributeDefinition: AttributeDefinition) => {
    if (!this.profile.customFields) {
      return true;
    }
    return !this.profile.customFields.find(
      (a) => a.attributeDefinitionId == attributeDefinition.id
    );
  };

  public getPortalProfileCustomFieldService(
    customField: AttributeDefinition
  ): IGenericAttributeService {
    return this.portalGenericAttributeFactoryService.BuildForPersonOnProfile(
      this.profile.id,
      customField
    );
  }

  deleteEmailFn = (emailId: string) => this.portalProfileService.deleteEmail(emailId);

  makePrimaryEmailFn = (email: PersonEmailModel) =>
    this.portalProfileService.makePrimaryEmail(email.id);

  addEmailFn = async (email: string): Promise<boolean> => {
    const result = await this.portalProfileService.addEmail(email);
    if (result.success && result.emailId) {
      this.onVerifyEmail({ id: result.emailId, email, isVerified: false });
    }
    return result.success;
  };

  onVerifyEmail(email: PersonEmailModel): void {
    const data: VerifyEmailDialogData = { emailId: email.id, email: email.email };
    this.dialog.open(VerifyEmailDialogComponent, { data, width: '440px', disableClose: false });
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}
